<!--
 * @description: 首页
 * @Author: Jay
 * @Date: 2021-09-17 09:33:29
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-16 15:42:11
-->
<template>
  <div>
    <!-- 视频区域 -->
    <top-video
      :videoList="homeData.home_file"
      v-if="homeData != ''"
    ></top-video>
    <!-- 居中 -->
    <div class="center" v-if="homeData != ''">
      <!-- 关于我们 -->
      <home-with :withData="homeData.about"></home-with>
      <!-- 边距 -->
      <div class="margin-top margin-bottom"></div>
      <!-- 自然科普馆 -->
      <home-sample
        :title="'自然科普馆'"
        :engTitle="'Science museum'"
        :carouselList="homeData.kepu.nav"
      ></home-sample>
      <!-- 边距 -->
      <div class="margin-top margin-bottom"></div>
      <!-- 科普巡展 -->
      <home-road-show
        :title="'科普巡展'"
        :engTitle="'The popular science tour'"
        :carouselList="homeData.xunzhan.nav"
      ></home-road-show>
      <!-- 边距 -->
      <div class="margin-top margin-bottom"></div>
      <!-- 科普文创 -->
      <home-sample
        :title="'科普文创'"
        :engTitle="'Popular science article'"
        :carouselList="homeData.wenchuang.nav"
      ></home-sample>
      <!-- 边距 -->
      <div class="margin-top margin-bottom"></div>
      <!-- 互动体验 -->
      <home-sample
        :title="'互动体验'"
        :engTitle="'interactive experience'"
        :carouselList="homeData.hudong.nav"
      ></home-sample>
      <!-- 边距 -->
      <div class="margin-top margin-bottom"></div>
    </div>
    <!-- 科普殿堂 -->
    <!-- <home-sliding
      :title="'科普殿堂'"
      :engTitle="'The popular science hall'"
      :slidingList="homeData.diantang.nav"
      v-if="homeData != ''"
    ></home-sliding> -->
    <!-- 边距 -->
    <!-- <div class="margin-top margin-bottom"></div> -->
  </div>
</template>

<script>
// 视频播放
import topVideo from "../../components/video/top-video.vue";
// 关于我们
import homeWith from "../../components/home/home-with.vue";
// 科普标本室 科普文创
import homeSample from "../../components/home/home-sample.vue";
// 科普巡展
import homeRoadShow from "../../components/home/home-roadshow.vue";
// 科普殿堂
// import homeSliding from "../../components/home/home-sliding.vue";
import { reHome } from "../../api/api";
export default {
  name: "Home",
  data() {
    return {
      homeData: [],
    };
  },
  components: {
    topVideo,
    homeWith,
    homeSample,
    homeRoadShow,
    // homeSliding,
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      //首页数据
      reHome().then((res) => {
        // console.log(res);
        this.homeData = res.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// 居中
.center {
  margin: 0 auto;
  width: 1280px;
  padding: 20px;
  // background-color: red;
}
</style>


